import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

const sortedByUpdate = [...mangaList].sort(
  (a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
);

const categoryMap: Record<string, string> = {
  riman: '日漫',
  hanman: '韩漫',
  guoman: '国漫',
};

export default function LatestUpdates() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              最近更新
            </h2>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            更多更新
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-product-shop="">
          {sortedByUpdate.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors duration-200 group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - 樱花漫画最新更新`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {categoryMap[manga.category] || manga.category}
                  </span>
                  <span className={`text-xs font-medium whitespace-nowrap ${
                    manga.status === '连载中' ? 'text-accent-500' : 'text-foreground-400'
                  }`}>
                    {manga.status}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 truncate">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{manga.latestChapter}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs text-foreground-400 whitespace-nowrap">{manga.updateTime}</p>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                  <i className="ri-eye-line w-3 h-3 inline-flex items-center justify-center mr-0.5"></i>
                  {(manga.views / 10000).toFixed(0)}万
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}